module.exports = __webpack_public_path__ + "img/manage-delete-icon.66e9c8d5.svg";